module.exports = __webpack_public_path__ + "static/img/stam.89659ea8.png";